//
//
//
//
//
//

export default {
  name: "Icon",
  props: {
    size: {
      type: String,
      default: "17px",
    },
  },
  computed: {
    style() {
      return `width: ${this.size}; height: ${this.size};`;
    },
  },
};
